// @flow

import React from 'react';
import type { BasicImage } from 'app/packages/pinterest-flow-types/image';
import zIndices from 'app/common/react/components/DeprecatedPinRep/styles/zIndices';
import { Box, Image } from 'gestalt';

type Props = {|
  isStoryPin?: boolean,
  onError?: () => void,
  onLoad?: () => void,
  pin: {
    dominant_color?: string,
    images: {
      '236x': BasicImage,
      '474x': BasicImage,
      '736x': BasicImage,
      orig: BasicImage,
    },
    title?: string,
  },
|};

export default function StoryPinImage({ onError, onLoad, pin }: Props) {
  const { title = '', dominant_color: dominantColor, images = {} } = pin;
  const paddingTop = `${(16 / 9) * 100}%`;

  const image = images['236x'].width > images['236x'].height ? images['736x'] : images['236x'];

  return (
    <Box position="relative" dangerouslySetInlineStyle={{ __style: { paddingTop } }}>
      <Box
        position="absolute"
        top
        left
        width="100%"
        height="100%"
        dangerouslySetInlineStyle={{
          __style: { zIndex: zIndices.storyPinImage },
        }}
      >
        <Image
          alt={title}
          color={dominantColor}
          naturalHeight={image.height}
          naturalWidth={image.width}
          onError={onError}
          onLoad={onLoad}
          src={image.url}
          fit="cover"
        />
      </Box>
    </Box>
  );
}
